import Vue from 'vue';
import BrandsComponent from '../components/home/brands-component.vue';
import { isHighDensity } from '../utils/high-resolution';

DM.Module.Brands = ((DM) => {
    const SELECTOR = '.js-brands';
    const ELEMENT = document.querySelector(SELECTOR);

    class Brands {
        constructor(element) {
            const model = this.getData();
            this.createComponent(element, model);
        }

        getData() {
            const mainPageData = DM.Boot.MainPage;
            const brands = mainPageData.mainPageBrands.brands.map(brand => {
                const image = isHighDensity ? brand.largeImageUrl : brand.imageUrl;
                return {
                    pictures: brand.pictures,
                    name: brand.name,
                    url: brand.url,
                    rel: brand.rel,
                    target: brand.rel === 'nofollow' ? '_blank' : '_self',
                };
            });
            return brands;
        }

        createComponent(element, model) {

            return new Vue({
                name: 'dm-brands-wrapper',
                el: element,
                components: {
                    'dm-brands': BrandsComponent
                },
                template: '<dm-brands :brands="model" />',
                data: {
                    model,
                },
            });
        }
    }
    if (ELEMENT) {
        new Brands(ELEMENT);
    }
})(window.DM);
